import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { Layout, NavDrawer, Panel, Sidebar } from 'react-toolbox/lib/layout'
import { Element } from 'react-scroll'

import Heading from './Heading'
import CSSModules from 'helpers/CSSModulesUtil'
import injectSagas from 'helpers/injectSagas'
import MainPanel from './MainPanel'

import Link from './Link'
import List from './List'
import styles from './styles.scss'

/*
import {
} from './actions'
import {
} from './selectors'
import {
} from './sagas'
*/

const mapStateToProps = (state) => {
  return {
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

class ProfilePage extends Component {
  render() {
    return (
      <Layout theme={styles}>
        <NavDrawer pinned scrollY theme={styles}>
          <Heading>
            Navigation
          </Heading>
          <List>
            <Link label='Substitutes' containerId='scrollContainer' to='Substitutes'/>
          </List>
        </NavDrawer>
        <Panel theme={styles}>
          <MainPanel/>
        </Panel>
      </Layout>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withStyles = CSSModules(styles)
//const withSagas = injectSagas({ sagas })
const enhance = compose(
  withConnect,
  //withSagas,
  withStyles
)

export default enhance(ProfilePage)
